// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/css/reset.css'
import './assets/css/theme.css'
import './assets/css/gxcode-dialog.css' //公信码模块element弹窗样式重写
// import VueImgmode from 'vue-imgmode'
import {getToken} from './request/common'
import MetaInfo from 'vue-meta-info'
import {substrNum} from '@/tools/tool'
import VueLazyLoad from 'vue-lazyload'
// Vue.use(VueImgmode)
import $ from 'jquery'
require('../bower_components/mark.js/dist/jquery.mark.min')
require('../static/jquery.qrcode.min')

Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.use(MetaInfo)
Vue.prototype.companyId = substrNum(window.location.href)
/* eslint-disable no-new */
// router.afterEach((to, from) => {
//     if (to.name !== 'index') {
//         document.body.style.paddingTop = '0px'
//     }
// })

Vue.use(VueLazyLoad, {
    error: require('../static/pic.jpg'),
    loading: require('../static/pic.jpg')
})

new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>',
    data () {
        return {
            // 转圈圈配置
            loadingOptions: {
                lock: false,
                text: '加载中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            }
        }
    },
    methods: {
        getToken
    }
})



// WEBPACK FOOTER //
// ./src/main.js